import { CanDeactivate } from '@angular/router';
import * as i0 from "@angular/core";
var EditChangesGuard = /** @class */ (function () {
    function EditChangesGuard() {
    }
    EditChangesGuard.prototype.canDeactivate = function (component) {
        if (component.canDeactivate) {
            return component.canDeactivate();
        }
        else {
            return false;
        }
    };
    EditChangesGuard.ngInjectableDef = i0.defineInjectable({ factory: function EditChangesGuard_Factory() { return new EditChangesGuard(); }, token: EditChangesGuard, providedIn: "root" });
    return EditChangesGuard;
}());
export { EditChangesGuard };
